export function parseStringToBool(value: string) {
  return value.toLowerCase() === 'true';
}
